module.exports = {"Operate8":{"daobanList":[{"title":"1:是否设立非学历教育机构？","values":[{"name":"是","xuanzhong":1,"cailiaoList":[{"name":"1、广东省非学历教育机构申报审批表","state":"必要"},{"name":"2、举办者及代理人","state":"必要"},{"name":"3、非学历教育机构设立收件清单","state":"必要"},{"name":"4、筹设批准书","state":"必要"},{"name":"5、办学场地","state":"必要"},{"name":"6、申请报告","state":"必要"},{"name":"7、培训机构材料","state":"必要"},{"name":"8、建设工程消防验收意见书","state":"必要"},{"name":"9、筹设申办报告","state":"必要"}]},{"name":"否","xuanzhong":0,"cailiaoList":[{"name":"无提交材料"}]}]}]}}


//////////////////
// WEBPACK FOOTER
// ./static/js/situation/sdo-8.json
// module id = 1288
// module chunks = 0